import type { Layout } from '../../layouts'
import type { RecommendationsType } from '../../models'
import { getModelsData, Model } from '../../models'
import { ModelRecommendations } from '../ModelRecommendations/ModelRecommendations'
import { MultiModelsRecommendedForYou } from '../MultiModelsRecommendedForYou/MultiModelsRecommendedForYou'

type RecommendedForYouContainerProps = {
  recommendations: RecommendationsType
  whichId: string
  layout: Layout
}

export const RecommendedForYouContainer = ({
  recommendations,
  whichId,
  layout,
}: RecommendedForYouContainerProps) => {
  const models = getModelsData(recommendations.models)

  if (models[Model.MIXED_ADVICE] && models[Model.CF_PAGE_LEVEL]) {
    return <MultiModelsRecommendedForYou models={models} whichId={whichId} layout={layout} />
  }

  const model = models[Model.MIXED_ADVICE] || models[Model.CF_PAGE_LEVEL]

  return <ModelRecommendations model={model} whichId={whichId} layout={layout} />
}
